
import React from "react";
import { useLocation, Navigate, Outlet } from "react-router-dom";
import useToken  from "../hooks/usetoken"
import useLocalStorage from "../hooks/useLocalStorage";
import FBNStructure from "../pages/FBNStructure/FBNStructure";

const Private = ({ Component }) => {
  const { pathname } = useLocation();
  const { token } = useToken();
  const { getLocalStorage } = useLocalStorage();
  const user = getLocalStorage("user");

  // If user is not authenticated, redirect to login
  if (!token || !user) {
    // return <Navigate to="/" state={{ from: pathname }} replace />;
  }

  // Render the protected component inside MainLayout
  return <FBNStructure>{Component ? <Component /> : <Outlet />}</FBNStructure>;
};

export default Private;
